var _defs, _rect, _path, _path2, _rect2, _rect3, _circle, _circle2, _path3, _path4, _path5, _circle3, _circle4, _rect4, _path6, _path7, _circle5, _circle6, _path8, _path9, _path0, _circle7, _circle8, _rect5, _path1, _path10, _circle9, _circle0, _rect6, _path11, _path12, _circle1, _circle10, _path13, _path14, _path15, _path16, _rect7, _circle11, _path17, _path18, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path19, _path20, _path21, _path22, _rect12, _rect13, _circle12, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustratieCompare({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 818.50324 322.19407",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f2f2f2;\n      }\n\n      .cls-2 {\n        fill: #454545;\n      }\n\n      .cls-3 {\n        fill: #f8f8f8;\n      }\n\n      .cls-4 {\n        fill: #e3e3e3;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #f8a542;\n      }\n\n      .cls-7 {\n        fill: #eb5241;\n      }\n\n      .cls-8 {\n        fill: #757575;\n      }\n\n      .cls-9 {\n        fill: #919191;\n      }\n\n      .cls-10 {\n        fill: #987f51;\n      }\n\n      .cls-11 {\n        fill: #e0c1a4;\n      }\n\n      .cls-12 {\n        fill: #c3104e;\n      }\n\n      .cls-13 {\n        fill: #ee135f;\n      }\n\n      .cls-14 {\n        fill: #afb9c5;\n      }\n\n      .cls-15 {\n        fill: #b7c4cd;\n      }\n\n      .cls-16 {\n        fill: #b1bac0;\n      }\n\n      .cls-17 {\n        fill: #bcd86b;\n      }\n\n      .cls-18 {\n        fill: #77c58c;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    className: "cls-1",
    x: 506.55625,
    width: 311.94699,
    height: 322.19,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Header",
    className: "cls-2",
    d: "M514.55625,0h295.947a8,8,0,0,1,8,8V25.142h-311.947V8A8,8,0,0,1,514.55625,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Container-2",
    className: "cls-3",
    d: "M525.18025,40.973h202.067a3.725,3.725,0,0,1,3.725,3.725V81.014a3.725,3.725,0,0,1-3.725,3.725h-202.067a3.725,3.725,0,0,1-3.725-3.725V44.698A3.725,3.725,0,0,1,525.18025,40.973Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    className: "cls-4",
    x: 529.83625,
    y: 54.103,
    width: 155.508,
    height: 6.565,
    rx: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Label-2",
    className: "cls-4",
    x: 529.83625,
    y: 65.044,
    width: 104.382,
    height: 6.565,
    rx: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-4",
    cx: 708.58025,
    cy: 62.856,
    r: 6.518
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    className: "cls-4",
    cx: 708.58125,
    cy: 62.857,
    r: 2.794
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Container-3",
    className: "cls-3",
    d: "M525.18025,92.186h202.067a3.725,3.725,0,0,1,3.725,3.725h0v28.866a3.725,3.725,0,0,1-3.725,3.725h-202.067a3.725,3.725,0,0,1-3.725-3.725V95.911A3.725,3.725,0,0,1,525.18025,92.186Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Label-3",
    className: "cls-4",
    d: "M532.56025,103.081h150.06a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-150.06a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,103.081Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Label-4",
    className: "cls-4",
    d: "M532.56025,112.16h98.934a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-98.934a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,112.16Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-2",
    className: "cls-4",
    cx: 708.58025,
    cy: 110.344,
    r: 6.518
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-2",
    className: "cls-4",
    cx: 708.58125,
    cy: 110.345,
    r: 2.794
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-4",
    className: "cls-3",
    x: 521.45525,
    y: 135.95399,
    width: 209.517,
    height: 36.316,
    rx: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Label-5",
    className: "cls-4",
    d: "M532.56025,146.849h150.06a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72376,2.72376,0,0,1-2.724,2.7235h-150.06a2.72376,2.72376,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,146.849Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Label-6",
    className: "cls-4",
    d: "M532.56025,155.928h98.934a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72376,2.72376,0,0,1-2.724,2.7235h-98.934a2.72376,2.72376,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,155.928Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-3",
    className: "cls-4",
    cx: 708.58025,
    cy: 154.112,
    r: 6.518
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-3",
    className: "cls-4",
    cx: 708.58125,
    cy: 154.11299,
    r: 2.794
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Container-5",
    className: "cls-3",
    d: "M525.18025,267.251h202.067a3.725,3.725,0,0,1,3.725,3.725h0v28.866a3.725,3.725,0,0,1-3.725,3.725h-202.067a3.725,3.725,0,0,1-3.725-3.725V270.976A3.725,3.725,0,0,1,525.18025,267.251Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Label-7",
    className: "cls-4",
    d: "M532.56025,278.146h150.06a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-150.06a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,278.146Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Label-8",
    className: "cls-4",
    d: "M532.56025,287.225h98.934a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-98.934a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,287.225Z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-4",
    className: "cls-4",
    cx: 708.58025,
    cy: 285.40901,
    r: 6.518
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-4",
    className: "cls-4",
    cx: 708.58125,
    cy: 285.41001,
    r: 2.794
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-6",
    className: "cls-3",
    x: 521.45525,
    y: 223.483,
    width: 209.517,
    height: 36.316,
    rx: 4
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Label-9",
    className: "cls-4",
    d: "M532.56025,234.378h150.06a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-150.06a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,234.378Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Label-10",
    className: "cls-4",
    d: "M532.56025,243.457h98.934a2.72376,2.72376,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-98.934a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72376,2.72376,0,0,1,532.56025,243.457Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-5",
    className: "cls-4",
    cx: 708.58025,
    cy: 241.641,
    r: 6.518
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-5",
    className: "cls-4",
    cx: 708.58125,
    cy: 241.642,
    r: 2.794
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Container-7",
    className: "cls-3",
    x: 521.45525,
    y: 179.71899,
    width: 209.517,
    height: 36.316,
    rx: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Label-11",
    className: "cls-4",
    d: "M532.56025,190.614h150.06a2.72376,2.72376,0,0,1,2.724,2.7235h0a2.72375,2.72375,0,0,1-2.724,2.7235h-150.06a2.72375,2.72375,0,0,1-2.724-2.7235h0A2.72376,2.72376,0,0,1,532.56025,190.614Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Label-12",
    className: "cls-4",
    d: "M532.56025,199.693h98.934a2.72375,2.72375,0,0,1,2.724,2.7235h0a2.72376,2.72376,0,0,1-2.724,2.7235h-98.934a2.72376,2.72376,0,0,1-2.724-2.7235h0A2.72375,2.72375,0,0,1,532.56025,199.693Z"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    id: "Background-6",
    className: "cls-4",
    cx: 708.58025,
    cy: 197.87699,
    r: 6.518
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    id: "Indicator-6",
    className: "cls-4",
    cx: 708.58125,
    cy: 197.87799,
    r: 2.794
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_584",
    "data-name": "Path 584",
    className: "cls-5",
    d: "M670.74425,18.16h-5.429v-.824h5.429Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_585",
    "data-name": "Path 585",
    className: "cls-5",
    d: "M651.49625,16.555V13.103h-2.3v3.452h-1.291V8.772h1.291v3.155h2.3V8.772h1.292v7.783Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_586",
    "data-name": "Path 586",
    className: "cls-5",
    d: "M663.12125,16.555l-2.183-5.5h-.032l.022,5.5h-1.173V8.772h1.487l2.161,5.529h.032l-.011-5.529h1.13v7.783Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_587",
    "data-name": "Path 587",
    className: "cls-5",
    d: "M657.19525,8.772h-1.618l-1.286,5.223-1.079.366.338,1.02.436-.148-.325,1.32h1.185l.433-1.76,2.047-.695.6,2.454h1.183Zm-1.613,4.784.765-3.107h.077l.641,2.6Z"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-7",
    className: "cls-3",
    x: 738.42126,
    y: 40.04,
    width: 65.183,
    height: 75.426,
    rx: 8
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    className: "cls-4",
    cx: 771.01226,
    cy: 68.908,
    r: 14.899
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Name",
    className: "cls-4",
    d: "M750.52726,87.532h40.971a2.79374,2.79374,0,0,1,2.794,2.7935h0a2.79374,2.79374,0,0,1-2.794,2.7935h-40.971a2.79374,2.79374,0,0,1-2.794-2.7935h0A2.79374,2.79374,0,0,1,750.52726,87.532Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Name-2",
    className: "cls-4",
    d: "M757.97626,96.844h26.072a2.79375,2.79375,0,0,1,2.794,2.7935h0a2.79375,2.79375,0,0,1-2.794,2.7935h-26.072a2.79375,2.79375,0,0,1-2.794-2.7935h0A2.79375,2.79375,0,0,1,757.97626,96.844Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Background-8",
    className: "cls-3",
    x: 738.42126,
    y: 122.918,
    width: 65.183,
    height: 180.64999,
    rx: 8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    className: "cls-4",
    x: 755.18226,
    y: 139.679,
    width: 31.66,
    height: 24.211,
    rx: 4
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-2",
    className: "cls-4",
    x: 755.18226,
    y: 171.339,
    width: 31.66,
    height: 23.28,
    rx: 4
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-3",
    className: "cls-4",
    x: 755.18226,
    y: 202.068,
    width: 31.66,
    height: 23.28,
    rx: 4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-4",
    className: "cls-4",
    x: 755.18226,
    y: 263.527,
    width: 31.66,
    height: 23.28,
    rx: 4
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Data-5",
    className: "cls-4",
    x: 755.18226,
    y: 232.797,
    width: 31.66,
    height: 23.28,
    rx: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_540",
    "data-name": "Path 540",
    className: "cls-6",
    d: "M559.14326,166.94005l-37.12805-90.439-37.129,90.439-2.953-1.21411,40.083-97.63892,40.082,97.63892Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_541",
    "data-name": "Path 541",
    className: "cls-7",
    d: "M476.36823,160.091a45.644,45.644,0,0,0,45.64393,45.644h.00109a45.64413,45.64413,0,0,0,45.645-45.64307v-.001Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_542",
    "data-name": "Path 542",
    className: "cls-6",
    d: "M340.02827,221.364l-37.12805-90.439-37.126,90.439-2.954-1.2129,40.07995-97.63989,40.082,97.63989Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_543",
    "data-name": "Path 543",
    className: "cls-8",
    d: "M460.36018,299.44578h0a4.549,4.549,0,0,0-4.547-4.551h-87.954a4.55,4.55,0,0,0-4.55,4.55v.001h0a4.549,4.549,0,0,1-4.548,4.54809h-8.51a4.55006,4.55006,0,0,0-4.55,4.54908V317.643a4.55188,4.55188,0,0,0,4.55,4.551h123.168a4.55011,4.55011,0,0,0,4.548-4.551V308.543a4.548,4.548,0,0,0-4.54687-4.54908h-8.51111A4.55,4.55,0,0,1,460.36018,299.44578Z"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2981",
    "data-name": "Rectangle 2981",
    className: "cls-8",
    x: 405.03825,
    y: 102.033,
    width: 13.593,
    height: 213.056
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2982",
    "data-name": "Rectangle 2982",
    className: "cls-8",
    x: 294.05884,
    y: 94.62555,
    width: 235.55099,
    height: 10.254,
    rx: 2.407,
    transform: "translate(-11.89977 102.49128) rotate(-13.986)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    className: "cls-6",
    cx: 411.83524,
    cy: 99.752,
    r: 16.688
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    className: "cls-7",
    d: "M257.25724,214.515a45.6429,45.6429,0,0,0,45.642,45.644h.00305a45.644,45.644,0,0,0,45.646-45.64209V214.515Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_545",
    "data-name": "Path 545",
    d: "M567.66221,160.091a45.665,45.665,0,0,1-45.649,45.6521,45.032,45.032,0,0,1-7.029-.55494,45.65,45.65,0,0,0,38.6-45.10009Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    "data-name": "Path 546",
    d: "M348.7852,214.515a45.66092,45.66092,0,0,1-45.649,45.647,44.8054,44.8054,0,0,1-7.03-.554,45.64791,45.64791,0,0,0,38.6-45.094Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Value",
    className: "cls-3",
    d: "M331.93324,53.045a12.808,12.808,0,1,1-9.361-21.5V7.827a36.718,36.718,0,0,0-36.725,36.486,36.718,36.718,0,0,0,36.724,36.487,36.285,36.285,0,0,0,26.73-11.552Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Value-2",
    className: "cls-9",
    d: "M322.33324,7.827V31.543a12.77,12.77,0,0,1,12.77,12.77h23.716A36.6,36.6,0,0,0,322.33324,7.827Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Value-3",
    className: "cls-4",
    d: "M335.14024,44.312a12.659,12.659,0,0,1-4.874,9.983l14.589,18.572a36.184,36.184,0,0,0,13.965-28.555Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Hair_Back",
    "data-name": "Hair Back",
    className: "cls-10",
    d: "M187.47352,57.32959l.016-.1192a16.77857,16.77857,0,0,1-11.45679-19.21373l3.12594-16.08644A16.77758,16.77758,0,0,1,198.82857,8.64109h0l1.53223.29775A16.77756,16.77756,0,0,1,213.92613,26.114c.75062,10.23679-.05921,32.784-4.23725,35.53252Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Head-2",
    className: "cls-11",
    d: "M173.19391,64.87087l12.06144-28.26844c-2.7236-4.83064-4.12653-10.373-2.62229-15.98437C186.96772,4.44848,209.08923,12.49,211.92,21.62652s-1.77425,30.02283-7.7989,30.38818c-2.403.14461-6.99516-2.24609-11.37525-6.19994l-1.16671,22.6318Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Hair_Front",
    "data-name": "Hair Front",
    className: "cls-10",
    d: "M184.4874,56.36118,162.275,52.04484a40.623,40.623,0,0,1,1.47195-6.9244A19.4738,19.4738,0,0,1,165.7821,40.606a18.23449,18.23449,0,0,1,5.04211-5.034c3.3239-2.48636,6.76-5.05693,8.66746-14.873.23309-.15041.45673-.3047.681-.45172.65108-.43409,1.26364-.84305,1.8696-1.20232l.09129-.601a31.48461,31.48461,0,0,1,5.13931-5.13029,20.80349,20.80349,0,0,1,5.40536-3.16336A11.60666,11.60666,0,0,1,199.06894,9.48c3.95138.76784,6.88847,2.18662,8.97007,4.33614a18.71088,18.71088,0,0,1,3.59979,6.01815l.00436.009a9.16024,9.16024,0,0,1-4.44477,4.1736A32.91147,32.91147,0,0,1,200.843,26.011a51.27651,51.27651,0,0,0-6.157,1.786,4.29145,4.29145,0,1,0-4.10574,6.96608l.19153.03721a86.37576,86.37576,0,0,1-2.36115,13.51458C187.58693,51.34722,186.23933,55.20836,184.4874,56.36118Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Skirt_Shadow",
    "data-name": "Skirt Shadow",
    className: "cls-12",
    d: "M142.31925,212.29s28.064,7.85,48.427,7.85,37.826-12.089,37.826-12.089-27.464-8.056-45.234-8.056S142.31925,212.29,142.31925,212.29Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Leg",
    className: "cls-11",
    d: "M206.94225,227.683a4.45982,4.45982,0,0,1-.454-.886c-2.5-6.614-42.559-77.962-46.549-91.007h45.1c3.034,9.918,16.69,72.158,18.613,84.576,6.064,19.588,18.55,83.025,20.144,87.419,1.677,4.623-7.758,9.437-10.271,3.756-4-9.044-13.531-34.068-17.776-49.347C211.76926,247.87,208.53125,234.984,206.94225,227.683Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Leg-2",
    className: "cls-11",
    d: "M170.04525,236.395c-18.314,4.628-85.3,13-89.9,14.309-4.729,1.35-8.876-8.4-3.03-10.508,9.3-3.36,34.928-11.122,50.466-14.29,12.5-2.548,23.9-4.627,31.559-5.845-.649-21.508-3.614-73.123-1.671-84.27h39.9c-1.864,10.69-17.618,88.691-20.546,96.5-.929,2.787-3.7,4.019-6.785,4.106Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "shoe",
    className: "cls-12",
    d: "M78.96826,239.569a1.56,1.56,0,0,0-1.306-1.778l-.077-.01-5.425-.553a50.01871,50.01871,0,0,0-5.942,1.763l7.653,43.328s5.882.7,5.685-3.014-.264-6.188-.264-6.188l5.42-21.723a.78.78,0,0,0-.56757-.94586l-.00043-.00012h-.022l-3.369-.74s-2.167-3.091-2.539-5.2Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "shoe-2",
    className: "cls-12",
    d: "M232.84126,309.737a1.56,1.56,0,0,0-1.978.976c-.009.024-.016.049-.023.075l-1.488,5.245a50.21574,50.21574,0,0,0,.7,6.156h43.989s1.716-5.668-1.979-6.121-6.138-.817-6.138-.817l-20.443-9.11207a.78.78,0,0,0-1.03.394l-.009.021-1.314,3.189s-3.42,1.6-5.559,1.6Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Skirt",
    className: "cls-13",
    d: "M157.60024,135.79s26.377-7.546,49.915,0c5.46,24.908,18.725,34.794,21.058,72.984-26.517,13.176-59.274-9.4-86.571,3.452C134.20025,194.254,145.12124,150.968,157.60024,135.79Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    className: "cls-11",
    d: "M98.62924,193.498c-.87-.537-1.823-2.558.48-4.134,5.739-3.939,14.006-10.825,15.126-13.092,2.285-4.637,22.283-64.311,22.283-64.311l17.08.065s-28.09,63.212-29.294,66.195c-1.8,4.472,2.014,11.284,3.647,14.944-2.574,1.152-3.77-.319-5.079-1.788-1.4-1.568-2.921-3.135-6.383-1.524-4.43,2.061-8.093,5.333-12.459,5.332A10.1349,10.1349,0,0,1,98.62924,193.498Zm134.622-88.663,30.794-4.2a67.13188,67.13188,0,0,1,17-6.961c1.456-.042,3.773.487.321,3.364s-6.951,6.058-6.336,7.593,3.822.964,4.356,3.325q.532,2.361-15.623.767l-24.987,9.908Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Clothes_Back",
    "data-name": "Clothes Back",
    className: "cls-14",
    d: "M183.29725,57.797l13.368.889c3.3,29.787,21.234,48.6,61.386,42.229l5.338,38.359c-37.525,4.855-70.444-10.165-77.2-50.845C184.44924,77.892,183.06824,66.935,183.29725,57.797Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Clothes",
    className: "cls-15",
    d: "M116.57726,168.541q13.926-74.093,58.786-114.648h1.326l.011.012,20.26,4.64c0,34.847,11.1,57.078,16.794,82.7h-54.717c-.77,8.852-1.248,17.953-1.491,27.3Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Shade",
    className: "cls-16",
    d: "M170.15924,141.249h-11.122c1.671-19.186,4.616-35.869,9-51.007-.6,10.1-.8,19.237-.6,27.141.256,10.066,1.17,18.094,2.72,23.862Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Leaf",
    className: "cls-17",
    d: "M4.84251,110.88452c7.89708-8.13393,15.82134-16.166,24.64426-23.32927,5.20178-4.22247,10.68-8.05878,16.0472-12.0602q-.92916.81427-1.82,1.67247c1.67518-1.13777,3.86868-1.77981,5.64272-2.83434,1.98078-1.17432,3.8749-2.5179,5.73263-3.87136,3.62948-2.64269,7.204-5.33552,10.92684-7.83775,4.15242-2.7898,8.45663-5.36879,12.67884-8.05339a114.1221,114.1221,0,0,1,11.04725-6.636c2.09028-1.01542,4.18478-2.2193,6.285-3.28112.70246-.3538,7.82884-4.85475,7.81046-4.8686-.3939-.29678-3.97826,1.38662-4.53478,1.61489-1.6221.6567-3.16948,1.45362-4.72724,2.24272A20.64171,20.64171,0,0,0,96.4753,38.32c.11411-.57538,1.02569-4.76607.55908-5.11764-.23331-.17579-2.50891,7.31984-2.62355,8.04389a13.32234,13.32234,0,0,1-.27187,1.9834c-.30849.89489-.29429.625-.97567,1.12872a42.70664,42.70664,0,0,1-4.25973,2.27555,31.14577,31.14577,0,0,1-4.34882,2.48524c-4.11426,1.99937-8.2845,5.07384-12.1939,7.62589a28.75,28.75,0,0,0,2.37568-6.05743c.13515-.50191,1.59624-5.00132,1.24148-5.26861-.3995-.301-3.18254,6.57307-3.34763,7.22277-.30658,1.20821-.36956,2.55362-.75351,3.72985-.4214,1.29079-1.73434,1.7483-2.91867,2.50059C64.60194,61.64,60.39677,64.5829,56.25873,67.65785,51.746,59.62948,56.953,49.93721,61.336,43.19892A56.02743,56.02743,0,0,1,73.24759,30.548,115.424,115.424,0,0,1,92.96094,18.28016a77.48723,77.48723,0,0,1,25.59385-7.86853A82.85783,82.85783,0,0,1,132.79,10.008a23.67567,23.67567,0,0,1,6.75839,1.15772,22.07507,22.07507,0,0,1,2.909,1.2511c.71569.36511,2.44794.75088,2.8589,1.296,3.38809,4.409,5.12172,8.80283,4.85724,14.34408A40.11014,40.11014,0,0,1,146.02,43.22867a46.5187,46.5187,0,0,1-9.939,13.903,105.61557,105.61557,0,0,1-10.37317,8.26494C113.01974,74.64926,96.929,82.69594,80.48983,80.63a43.74134,43.74134,0,0,1-15.1124-5.05707c-1.11454-.59549-2.22226-1.19837-3.27414-1.902-.70965-.47455-2.60592-2.611-3.319-2.68858-.97615-.10919-3.08418,1.88238-4.00348,2.4874Q44.32016,80.37114,34.37243,87.97336c-7.07187,5.37123-13.79661,11.108-20.32345,17.11405-2.77534,2.55473-5.53409,5.1157-8.22958,7.75565-.6272.61467-2.1672,2.8764-3.29929,2.97915a1.0224,1.0224,0,0,1-1.10017-1.21471c.17862-1.15807,2.61381-2.89062,3.42257-3.723"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Leaf-2",
    className: "cls-18",
    d: "M41.48078,18.68657c.10351-.96242,1.62246-1.49844,1.39907-.28991-.18442.97839-.113.95554.42173,1.66961.43415.57926,1.0507,1.091,1.531,1.64392a24.02209,24.02209,0,0,1,2.71975,3.74426,31.89983,31.89983,0,0,1,3.5189,9.24958c1.22017,5.65559,1.94629,11.70713,1.12071,17.41817A61.536,61.536,0,0,1,41.75547,77.82309c-3.20924,4.56985-6.94426,8.38343-12.45173,9.9126a18.265,18.265,0,0,1-8.54267.43062c-.74525-.15351-1.48776-.51754-2.23333-.62861-1.14916-.16935-.81884-.17141-1.552.93227q-1.19918,1.81484-2.407,3.61862a104.54143,104.54143,0,0,1-6.70628,9.20477A30.039,30.039,0,0,1,5.2863,103.996c-.69243.63833-3.15694,3.31509-4.35469,3.24-1.99346-.12456-.26829-1.91423.39746-2.40792.58536-.43584,1.15365-.89876,1.7041-1.3774a31.97143,31.97143,0,0,0,3.79565-3.98836c1.24972-1.545,2.39521-3.18367,3.545-4.80354,1.06793-1.51763,2.108-3.05509,3.13724-4.59969q.85755-1.28769,1.70591-2.58c.19395-.29366.71441-.72914.2865-.87355a49.06156,49.06156,0,0,0,3.12289-5.8674c1.21051-2.38458,2.40625-4.78212,3.42319-7.26412a56.322,56.322,0,0,0,1.94575-5.46663,29.369,29.369,0,0,0,.75593-3.3071c.10456-.61574.77656-2.92779.42874-3.44345.14931.22135-1.122,2.5372-1.24682,2.84934-.49916,1.245-.91942,2.51392-1.32827,3.79085a62.22772,62.22772,0,0,1-2.66155,6.96267c-.39457-.18618-.4141-2.0535-.513-2.54888a23.95712,23.95712,0,0,0-.86982-3.28887,26.383,26.383,0,0,0-2.56009-5.76261,11.46117,11.46117,0,0,1,.40783,2.68979,30.633,30.633,0,0,0,.72312,2.98375c.27032.90327.60265,1.78762.96017,2.661s1.28474,2.26237,1.3405,3.23918c.00365.05906-.41949.28295-.41377.52034s.36069.69032.358.74886c-.04333.86031-1.01626,2.09675-1.3952,2.85292-.98315,1.95984-1.99385,3.90567-2.994,5.85645-.30986.60464-.40182,1.19257-.96468,1.22363-.59835.03208-1.67588-.995-2.14853-1.36128a13.30492,13.30492,0,0,1-4.07021-5.0311,23.866,23.866,0,0,1-1.96866-11.844C6.9454,52.15422,11.36741,36.95376,22.44535,25.752c4.59008-4.64,12.08445-11.3584,19.0363-7.05874"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Leave_the_Leaf_",
    "data-name": "Leave the Leaf ",
    className: "cls-18",
    d: "M1.681,113.78253a1.07442,1.07442,0,0,1,.04738-.91287c.35139-.94722,2.827-1.91076,4.15689-2.42825.23691-.09264.441-.17182.57611-.22917a30.14047,30.14047,0,0,1,3.51581-1.254,105.16989,105.16989,0,0,1,11.13572-2.3867c1.38383-.23871,2.8284-.4859,4.28336-.72779.27019-.04505.47912-.0636.64236-.08544.59487-.06519.59487-.06519.803-.81906l.035-.13271a7.31706,7.31706,0,0,0,.194-1.25568,8.95767,8.95767,0,0,1,.14161-1.04135,18.11807,18.11807,0,0,1,3.86815-7.62988,18.38128,18.38128,0,0,1,6.36933-4.92423,31.49289,31.49289,0,0,1,7.74934-2.42A63.03679,63.03679,0,0,1,59.06756,86.41a56.97473,56.97473,0,0,1,13.85675,2.04241c4.797,1.35447,9.85365,4.00542,15.45894,8.10593a31.91793,31.91793,0,0,1,7.01931,6.97618c.27253.37566.54135.77369.79681,1.18242a26.149,26.149,0,0,1,1.51792,2.8249c.12762.274.24115.57452.35256.86221a9.43484,9.43484,0,0,0,.52533,1.20469l.09985.18052c.06954.12635.12381.2245.17628.30846.212.3392.39273.41138,1.07717.57441a.728.728,0,0,1,.46895.273.433.433,0,0,1-.07537.50583,1.189,1.189,0,0,1-1.22684.38234,8.891,8.891,0,0,1-.89464,5.36106,12.82006,12.82006,0,0,1-3.498,4.073,37.00008,37.00008,0,0,1-9.79334,5.08545,50.441,50.441,0,0,1-11.20591,2.80085,57.7689,57.7689,0,0,1-11.38.33178,83.05645,83.05645,0,0,1-22.58648-5.05334A23.74709,23.74709,0,0,1,29.738,117.8189a12.72691,12.72691,0,0,1-1.24879-1.67352,13.94817,13.94817,0,0,1-1.69293-4.09171c-.02724-.11151-.06667-.252-.11352-.41372a3.962,3.962,0,0,1-.25387-2.10431c.19864-.38594.58512-.38457,1.06212-.37609.14257.0017.29044.00244.44467-.00551q.89155-.049,1.78429-.09985c1.56753-.08819,3.189-.18063,4.78357-.25387.25228-.01145.5671-.05491.89973-.10007a5.33712,5.33712,0,0,1,2.27434-.01579.7353.7353,0,0,1,.12211.15953,1.542,1.542,0,0,0,.41552.47615c.14119.06742.355-.04144.49724-.11384.07156-.03646.12731-.06423.1448-.05512a6.7789,6.7789,0,0,1,1.71285,1.716c.251.31482.48654.60865.69791.828.583.60261,1.28206,1.306,2.04092,1.95792a30.42207,30.42207,0,0,0,2.431,1.87451,8.8799,8.8799,0,0,0,.781.44583,5.45,5.45,0,0,1,1.48241.97563,26.34873,26.34873,0,0,0-4.1976-4.64068,23.99914,23.99914,0,0,0-2.65042-2.13124c-.11257-.07822-.32118-.19313-.55915-.3286a5.34175,5.34175,0,0,1-1.51187-1.03975.27507.27507,0,0,1-.0476-.13653,62.64186,62.64186,0,0,1,7.44332.39983c1.27963.14363,2.65159.28027,4.00691.33178.08787.00286.33687-.01007.65116-.02607a8.45515,8.45515,0,0,1,2.45708.04452c-.25758-.41213-1.78366-.7048-2.69473-.87948-.26659-.04919-.4911-.09519-.62551-.12911a29.38817,29.38817,0,0,0-3.32957-.6537,56.22882,56.22882,0,0,0-5.7841-.4451c-2.74084-.08533-5.46727.03731-8.029.17257-.58915.031-1.20013.0496-1.7914.06773a30.84083,30.84083,0,0,0-4.83975.39983.261.261,0,0,0-.02618-.16642c-.088-.14076-.35711-.06572-.61755.00626a2.77518,2.77518,0,0,1-.27.06614c-1.03286.17384-2.04707.336-3.05078.50933-2.12191.36157-3.86264.67829-5.478.99566l-.086.01717c-1.891.37058-3.85416.7579-5.74616,1.26469a31.71046,31.71046,0,0,0-5.18276,1.84535c-.66473.30815-1.32108.6429-1.95051.99619C3.58,113.77373,2.05408,114.37952,1.681,113.78253Zm30.55258-15.152a19.67834,19.67834,0,0,0-2.75706,5.40007c.52746-1.18816,1.0335-2.24265,1.54718-3.22643.11671-.22271.37121-.66833.61671-1.10007C31.949,99.16577,32.238,98.65845,32.23355,98.63057Zm20.20827,3.752c-.17543-.28069-2.87175.98824-3.30805,1.21847a14.42,14.42,0,0,0-3.81716,3.05672l-.00594.00371.00679-.00424a18.60753,18.60753,0,0,1,2.05459-1.11078c2.07877-1.05512,4.92424-2.49863,5.0808-3.05757A.13.13,0,0,0,52.44182,102.38255Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratieCompare);
export default __webpack_public_path__ + "static/media/illustratie_compare.b6032a891edf9450f522f738e98de6ca.svg";
export { ForwardRef as ReactComponent };